import { PageHero } from "@/components/Section";
import Reveal from "@/components/Reveal";
import EarlyAccessForm from "@/components/EarlyAccessForm";
import PincodeChecker from "@/components/PincodeChecker";
import { useBrand } from "@/context/BrandContext";
import media from "@/config/media";

export default function EarlyAccessPage() {
  const brand = useBrand();
  return (
    <>
      <PageHero
        eyebrow="Get started"
        title={`Start your child’s meal plan with ${brand.name}.`}
        intro="Tell us about your child, your area and the plan you want. We confirm your delivery window, pricing and start date with you before anything is charged."
      />

      <section className="py-14 sm:py-20">
        <div className="mbm-container grid gap-12 lg:grid-cols-[1fr_0.8fr] lg:items-start">
          <Reveal>
            <EarlyAccessForm title="Your plan details" />
          </Reveal>
          <Reveal delay={120} className="lg:sticky lg:top-28">
            <PincodeChecker />
            <div className="mt-6 overflow-hidden rounded-[32px] shadow-softLg">
              <img
                src={media.deliveryPackaging}
                alt="Sealed meal containers in an insulated delivery bag at a doorstep"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="mt-6 rounded-card bg-surface shadow-soft p-6">
              <p className="mbm-eyebrow">What happens next</p>
              <ol className="mt-3 space-y-2.5 text-sm leading-relaxed text-cocoa/70">
                <li>1. We confirm that your area is in our delivery zone.</li>
                <li>2. We share your plan pricing, portion details and delivery window.</li>
                <li>3. If your child has an allergy, we speak to you before anything is confirmed.</li>
                <li>4. You choose a start date. Nothing is charged until you agree.</li>
              </ol>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
